(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/bigstat-modal.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/bigstat-modal.js');
'use strict';

const {
  Modal,
  ModalPortal
} = svs.components.lbUi.modal;
const BigStat = svs.components.sportinfo.bigstat.BigStat;
const {
  useEffect,
  useState
} = React;
const BigStatModal = _ref => {
  let {
    isOpen,
    className = '',
    elSelector,
    BigStatProps,
    Bottom
  } = _ref;
  const [el, setEl] = useState();
  useEffect(() => {
    var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4;
    if (!el) {
      return;
    }
    const stickyBottom = ((_document$querySelect = document.querySelector('.sticky-bottom')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 0;
    const headerTitle = ((_document$querySelect2 = document.querySelector('.header-title')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.offsetHeight) || 0;
    const balanceBar = ((_document$querySelect3 = document.querySelector('.balance-bar-legal')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.offsetHeight) || 0;
    const topBar = ((_document$querySelect4 = document.querySelector('.balance-bar-libuttons')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.offsetHeight) || 0;
    const betslipOffset = BigStatProps.Betslip ? 44 : 0;
    const pixels = headerTitle + balanceBar + topBar + stickyBottom - betslipOffset;
    el.style.setProperty('min-height', "calc(100vh - ".concat(pixels, "px)"));
    const nav = document.querySelector(elSelector);
    const navPadding = nav === null || nav === void 0 ? void 0 : nav.style.paddingBottom;
    if (nav && isOpen) {
      nav.style.paddingBottom = '0px';
    }
    return () => {
      if (nav) {
        nav.style.paddingBottom = navPadding;
      }
    };
  }, [isOpen, el]);
  return React.createElement(ModalPortal, null, React.createElement(Modal, {
    className: className,
    isOpen: isOpen
  }, React.createElement("div", {
    className: "bigstat-modal-handler",
    ref: node => {
      if (node) {
        setEl(node);
      }
    }
  }, React.createElement(BigStat, BigStatProps)), svs.core.detect.formfactor.mobile() && React.createElement(Bottom, null)));
};
setGlobal('svs.components.sportinfo.bigstat.BigStatModal', BigStatModal);

 })(window);